const hours = Array.from({ length: 24 }, (_, i) => i).filter(
  hour => hour !== 12
);
const minutes = Array.from({ length: 12 }, (_, i) => i * 5);

export const hoursOptions = hours.reverse().map(hour => ({
  text: hour === 0 ? '12 AM' : hour < 13 ? `${hour} AM` : `${hour - 12} PM`,
  value: hour,
}));

export const minutesOptions = minutes.map(minute => ({
  text: minute.toString(),
  value: minute,
}));
